import { render, staticRenderFns } from "./FormDocument.vue?vue&type=template&id=7a3b57f0&scoped=true"
import script from "./FormDocument.vue?vue&type=script&lang=js"
export * from "./FormDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3b57f0",
  null
  
)

export default component.exports